// extracted by mini-css-extract-plugin
export default {"root":"styles_root__sM+PM","list":"styles_list__yF3G3"};